/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    BookingTolerancesListConfiguration,
    BookingTolerancesListConfigurationFromJSON,
    BookingTolerancesListConfigurationToJSON,
    BookingTolerancesListItem,
    BookingTolerancesListItemFromJSON,
    BookingTolerancesListItemToJSON,
    BookingTolerancesListQuery,
    BookingTolerancesListQueryFromJSON,
    BookingTolerancesListQueryToJSON,
} from '../models';

export interface ApiBookingTolerancesBookingTolerancesListDataPostRequest {
    bookingTolerancesListQuery?: BookingTolerancesListQuery;
}

export interface ApiBookingTolerancesBookingTolerancesListDeleteDeleteRequest {
    id?: string;
}

/**
 * no description
 */
export class BookingTolerancesListApi extends runtime.BaseAPI {

    /**
     */
    async apiBookingTolerancesBookingTolerancesListConfigurationGetRaw(): Promise<runtime.ApiResponse<BookingTolerancesListConfiguration>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/BookingTolerances/BookingTolerancesList/Configuration`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => BookingTolerancesListConfigurationFromJSON(jsonValue));
    }

    /**
     */
    async apiBookingTolerancesBookingTolerancesListConfigurationGet(): Promise<BookingTolerancesListConfiguration> {
        const response = await this.apiBookingTolerancesBookingTolerancesListConfigurationGetRaw();
        return await response.value();
    }

    /**
     */
    async apiBookingTolerancesBookingTolerancesListDataPostRaw(requestParameters: ApiBookingTolerancesBookingTolerancesListDataPostRequest): Promise<runtime.ApiResponse<Array<BookingTolerancesListItem>>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/BookingTolerances/BookingTolerancesList/Data`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: BookingTolerancesListQueryToJSON(requestParameters.bookingTolerancesListQuery),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(BookingTolerancesListItemFromJSON));
    }

    /**
     */
    async apiBookingTolerancesBookingTolerancesListDataPost(requestParameters: ApiBookingTolerancesBookingTolerancesListDataPostRequest): Promise<Array<BookingTolerancesListItem>> {
        const response = await this.apiBookingTolerancesBookingTolerancesListDataPostRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async apiBookingTolerancesBookingTolerancesListDeleteDeleteRaw(requestParameters: ApiBookingTolerancesBookingTolerancesListDeleteDeleteRequest): Promise<runtime.ApiResponse<void>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.id !== undefined) {
            queryParameters['id'] = requestParameters.id;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/BookingTolerances/BookingTolerancesList/Delete`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiBookingTolerancesBookingTolerancesListDeleteDelete(requestParameters: ApiBookingTolerancesBookingTolerancesListDeleteDeleteRequest): Promise<void> {
        await this.apiBookingTolerancesBookingTolerancesListDeleteDeleteRaw(requestParameters);
    }

}
